var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "goods_drawer_inner_padding" }, [
    _c(
      "div",
      {
        staticClass: "goods_drawer_inner",
        style: { backgroundColor: _vm.value.config.bg_color || "#fff" },
      },
      [
        _vm.value.config.type === "1"
          ? _c("div", { staticClass: "header" }, [
              _c("div", { staticClass: "title" }, [
                _vm._v(_vm._s(_vm.value.config.name)),
              ]),
            ])
          : _vm._e(),
        _vm.value.config.type === "2"
          ? _c("el-image", {
              staticStyle: { width: "100%" },
              attrs: { src: _vm.value.config.header_image },
            })
          : _vm._e(),
        _c(
          "div",
          { staticClass: "content" },
          _vm._l(_vm.goodsList, function (item, index) {
            return _c(
              "div",
              { key: index, staticClass: "product" },
              [
                _c("el-image", {
                  staticClass: "img",
                  attrs: { src: item.thumb },
                }),
                _c("div", { staticClass: "productName" }, [
                  _vm._v(" " + _vm._s(item.movie_name) + " "),
                ]),
                _c("div", { staticClass: "price" }, [
                  _vm._v(_vm._s(item.publish_time)),
                ]),
              ],
              1
            )
          }),
          0
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }